import React from 'react';
import I18n from 'i18n-js';
import useRebook from 'components/v2/anytime-booking/common/use-rebook';
import HistoryBookingFilter from './history-booking-filter';
import HistoryBookingTable from './history-booking-table';
import HistoryBookingAction from './history-booking-action';
import commonStyles from './new-booking-table-page.less';

const HistoryBookingSection = () => {
  const rebookBookings = useRebook({});

  return (
    <div className={commonStyles.section}>
      <div className={commonStyles.header}>
        <h5>{I18n.t('v2.bookingsPage.pastBookings')}</h5>
      </div>
      <div className={commonStyles.filterAction}>
        <HistoryBookingFilter />
        <HistoryBookingAction rebookBookings={rebookBookings} />
      </div>
      <HistoryBookingTable rebookBookings={rebookBookings} />
    </div>
  );
};

export default HistoryBookingSection;
